import { uploadMediaAction } from 'store/actions/media.action'

export const uploadFileService =
  (selectedModel, setSelectedModel, setLoading, files, item, single = false) =>
  async (dispatch) => {
    let tempModel = structuredClone(selectedModel)
    setLoading(true)
    for (const file of files) {
      const formData = new FormData()
      formData.append('media', file)
      await dispatch(
        uploadMediaAction(formData, false, (url) => {
          if (tempModel.args[item].value?.length && !single)
            tempModel.args[item].value = tempModel.args[item].value + ',' + url
          else tempModel.args[item].value = url
        })
      )
    }
    setLoading(false)
    setSelectedModel(tempModel)
  }

export const uploadMaskService =
  (selectedModel, setSelectedModel, setEmptyFieldsExist, file, item) => async (dispatch) => {
    const formData = new FormData()
    formData.append('media', file, 'output.png')
    let tempModel = structuredClone(selectedModel)

    await dispatch(
      uploadMediaAction(
        formData,
        false,
        (url) => {
          tempModel.args[item].value = url
        },
        null,
        ['mask']
      )
    )
    const argsArray = Object.keys(tempModel.args)
    const emptyFieldData = argsArray.filter(
      (item) =>
        tempModel?.args[item].optional === false && (tempModel?.args[item].value === '' || !tempModel?.args[item].value)
    )
    setSelectedModel(tempModel)
    setEmptyFieldsExist(emptyFieldData)
  }

export const removeImageService = (selectedModel, setSelectedModel, itemKey, index = null) => {
  let tempModel = structuredClone(selectedModel)

  if (index == null) tempModel.args[itemKey].value = ''
  else {
    let valueList = tempModel.args[itemKey].value.split(',')
    valueList.splice(index, 1)
    tempModel.args[itemKey].value = valueList.join(',')
  }

  setSelectedModel(tempModel)
}

/**
 * Downloads a file from the given URL
 * @param {string} url - The URL of the file to download
 * @returns {Promise<File>} - Returns the File object for cases where it's needed for upload
 */
export const downloadFile = async (url) => {
  try {
    if (!url) {
      console.error('No URL provided for download')
      return
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {},
      mode: 'cors',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()

    // Extract filename from URL or use default
    const urlPath = url.split('/')
    const urlWithParams = urlPath[urlPath.length - 1]
    const filename = urlWithParams.split('?')[0] || 'download'

    // Get file extension
    const extension = filename.includes('.') ? filename.split('.').pop() : 'png'
    const finalFilename = filename.includes('.') ? filename : `${filename}.${extension}`

    // Create download link and trigger download
    const downloadUrl = window.URL.createObjectURL(blob)
    const downloadLink = document.createElement('a')
    downloadLink.href = downloadUrl
    downloadLink.setAttribute('download', finalFilename)
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)

    // Clean up the object URL to free memory
    window.URL.revokeObjectURL(downloadUrl)

    // Return File object for cases where it's needed (like for uploads)
    return new File([blob], finalFilename, { type: blob.type })
  } catch (error) {
    console.error('Error downloading the file:', error)
    throw error
  }
}
